export function getStyleUrls(light: boolean, sharedDependenciesNames: string[], el: HTMLElement) {
    function getCssUrl(dependencyName: string, cssFileRegEx: RegExp) {
        if (light && sharedDependenciesNames.includes(dependencyName)) {
            return Array.from(document.getElementsByTagName('link')).find(
                ({ href }) => href && cssFileRegEx.test(href)
            )?.href;
        }
    }

    const designSystemUrl = getCssUrl(
        '@servicetitan/design-system',
        /design-system(\..+)?\.bundle\.css/
    );
    const anvil2CssUrl = getCssUrl('@servicetitan/anvil2', /anvil2(\..+)?\.bundle\.css/);

    return [
        ...(designSystemUrl ? [designSystemUrl] : []),
        ...(anvil2CssUrl ? [anvil2CssUrl] : []),
        ...(el.hasAttribute('style-urls')
            ? JSON.parse(decodeURIComponent(el.getAttribute('style-urls')!))
            : []),
    ];
}
